import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {getDeliveryTask,getDeliveryTasks,postDeliveryTask,bulkAssignDeliveryTask,exportDeliveryTasks,importDeliveryTasks,DeliveryTaskTemplate,validateDeliveryTask,countEmployee,removeDeliveryTask,getdeliveryStatus,getdeliveryValidation,postdeliveryValidation,validatePackageTrackingId,submitDeliveryValidation,
  makeOfd,countTasks,exportDeliveryValidation,exportDelValidation,removeDeliveryValidation,deleteDeliveryValidation,startCourierDebreif,countCourierDebreif,
  addDebreifing,getDelValidation,getDlValidation,getDebriefingCount,uploadProof,getDeliveryAuditbyCode,deleteDeliveryAudit,getDeliveryAudit,submitDebreifing,downloadDebriefProof,deleteDebreifing,getDebreifHistory,exportDebreifingHistory,getDebreif,startDebreifing,getAssignedPackages,getDebreifingScans,scanPackageLevel,getDiscrepancyScans,submitDebrief,getDiscrepancies,getDeliverySheets,getDebriefingReport,getDebriefingProblems,downloadDebriefingReport,completeDebriefingReport,revokeDebriefing
} from "../../services/DeliveryMgt/Delivery_services";
const initialValues = {
  deliveryStatusList: [],
  deliverySheetData: [],
  discrepancyData: []
};
let deliveryStore = (set) => ({
  ...initialValues,
  getDeliveryTask: async (params) => {
    const response = await getDeliveryTask(params);
    return response;
  },
   getDeliveryTasks: async (params) => {
    const response = await getDeliveryTasks(params);
    return response;
  },
  postDeliveryTask: async (data) => {
    const response = await postDeliveryTask(data);
    return response;
  },
  bulkAssignDeliveryTask: async (data) => {
    const response = await bulkAssignDeliveryTask(data);
    return response;
  },
  exportDeliveryTasks: async (data) => {
    const response = await exportDeliveryTasks(data);
    return response;
  },
  importDeliveryTasks: async (data) => {
    const response = await importDeliveryTasks(data);
    return response;
  },
  DeliveryTaskTemplate: async (data) => {
    const response = await DeliveryTaskTemplate(data);
    return response;
  },
  validateDeliveryTask: async (params) => {
    const response = await validateDeliveryTask(params);
    return response;
  },
  countEmployee: async (params) => {
    const response = await countEmployee(params);
    return response;
  },
  removeDeliveryTask: async (params) => {
    const response = await removeDeliveryTask(params);
    return response;
  },
  getdeliveryStatus: async (params) => {
    const response = await getdeliveryStatus(params);
    set({ deliveryStatusList: response });
    return response;
  },
  getdeliveryValidation: async (params) => {
    const response = await getdeliveryValidation(params);
    return response;
  },
  postdeliveryValidation: async (params) => {
    const response = await postdeliveryValidation(params);
    return response;
  },
  makeOfd: async (params) => {
    const response = await makeOfd(params);
    return response;
  },
  countTasks: async (params) => {
    const response = await countTasks(params);
    return response;
  },
  validatePackageTrackingId: async (params,data) => {
    const response = await validatePackageTrackingId(params,data);
    return response;
  },
  submitDeliveryValidation: async (params) => {
    const response = await submitDeliveryValidation(params);
    return response;
  },
  exportDeliveryValidation: async (params) => {
    const response = await exportDeliveryValidation(params);
    return response;
  },
  exportDelValidation: async (params) => {
    const response = await exportDelValidation(params);
    return response;
  },
  deleteDeliveryValidation: async (params) => {
    const response = await deleteDeliveryValidation(params);
    return response;
  },
  removeDeliveryValidation: async (params) => {
    const response = await removeDeliveryValidation(params);
    return response;
  },
  startCourierDebreif: async (params) => {
    const response = await startCourierDebreif(params);
    return response;
  },
  countCourierDebreif: async (params) => {
    const response = await countCourierDebreif(params);
    return response;
  },
  getDebreif: async (params) => {
    const response = await getDebreif(params);
    return response;
  },
  addDebreifing: async (params) => {
    const response = await addDebreifing(params);
    return response;
  },
  submitDebreifing: async (params) => {
    const response = await submitDebreifing(params);
    return response;
  },
  deleteDebreifing: async (params) => {
    const response = await deleteDebreifing(params);
    return response;
  },
  getDebreifHistory: async (params) => {
    const response = await getDebreifHistory(params);
    return response;
  },
  downloadDebriefProof: async (params) => {
    const response = await downloadDebriefProof(params);
    return response;
  },
  exportDebreifingHistory: async (params) => {
    const response = await exportDebreifingHistory(params);
    return response;
  },
  getDelValidation: async (params) => {
    const response = await getDelValidation(params);
    return response;
  },
   getDlValidation: async (params) => {
    const response = await getDlValidation(params);
    return response;
  },
  getDeliveryAuditbyCode: async (params) => {
    const response = await getDeliveryAuditbyCode(params);
    return response;
  },
  getDeliveryAudit: async (params) => {
    const response = await getDeliveryAudit(params);
    return response;
  },
  deleteDeliveryAudit: async (params) => {
    const response = await deleteDeliveryAudit(params);
    return response;
  },
  startDebreifing: async (params) => {
    const response = await startDebreifing(params);
    return response;
  },
  getAssignedPackages: async (params,data) => {
    const response = await getAssignedPackages(params,data);
    return response;
  },
  getDebreifingScans: async (params) => {
    const response = await getDebreifingScans(params);
    return response;
  },
  scanPackageLevel: async (params,data) => {
    const response = await scanPackageLevel(params,data);
    return response;
  },
  getDiscrepancyScans: async (params) => {
    const response = await getDiscrepancyScans(params);
    return response;
  },
  submitDebrief: async (params) => {
    const response = await submitDebrief(params);
    return response;
  },
  getDiscrepancies: async () => {
    const response = await getDiscrepancies();
    set({ discrepancyData: response?.data?.data });
    return response;
  },
  getDeliverySheets: async (params) => {
    const response = await getDeliverySheets(params);
    set({ deliverySheetData: response?.data?.data });
    return response;
  },
  getDebriefingReport: async (params) => {
    const response = await getDebriefingReport(params);
    return response;
  },
  getDebriefingCount: async (params) => {
    const response = await getDebriefingCount(params);
    return response;
  },
  getDebriefingProblems: async (params) => {
    const response = await getDebriefingProblems(params);
    return response;
  },
  uploadProof: async (params,data) => {
    const response = await uploadProof(params,data);
    return response;
  },
  downloadDebriefingReport: async (params) => {
    const response = await downloadDebriefingReport(params);
    return response;
  },
  completeDebriefingReport: async (params) => {
    const response = await completeDebriefingReport(params);
    return response;
  },
  revokeDebriefing: async (params) => {
    const response = await revokeDebriefing(params);
    return response;
  },
  setDelSheet: (data) => set({ deliverySheetData: data }),
});

deliveryStore = devtools(deliveryStore);

export const useDeliveryStore = create(deliveryStore);
